const ideas = (state = null, action) => {
    switch (action.type) {
        case 'GET_IDEAS_SUCCESS':
            return action.payload.response;
        case 'GET_IDEAS_ERROR':
            if (action.payload.response.status >= 400 && action.payload.response.status < 500) {
                localStorage.removeItem('id_token');
                return window.location = '/';
            }
            break;
        default:
            return state;
    }
}

export default ideas;



// WEBPACK FOOTER //
// ./src/reducers/ideas/index.js